<app-base-list-page
  [headersList]="headerList"
  (rowClick)="requisitionNumberClicked($event)"
  [extraBurgerMenuOptions]="extraBurgerMenuOptions"
  [logHeaderList]="logHeaderList"
  [multiSelectFilterLists]="multiSelectFilterLists"
  [createNew]="requisitionNumberClicked"
  [switchDataToggle]="switchDataInList"
  newItemLabel="Nyt rekvisitionsnummer"
  #baseListPage
>
</app-base-list-page>
